import { dateSerializer } from 'domain/entity/common/utils';
import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum ReportInstanceScope {
    ME = 'ME',
    ALL_DEPLOYMENT_EXCEPT = 'ALL_DEPLOYMENT_EXCEPT',
    SPECIFIC_USERS = 'SPECIFIC_USERS',
}

@JsonObject()
export class ReportInstanceContext {
    constructor(
        @JsonProperty({ required: true }) readonly userId: string,
        @JsonProperty({ required: true }) readonly language: string,
        @JsonProperty({ required: true }) readonly languageName: string,
        @JsonProperty({ required: true }) readonly locationId: string,
        @JsonProperty({ required: true }) readonly locationName: string,
        @JsonProperty({ required: true }) readonly locationTags: string,
        @JsonProperty({ required: true, beforeDeserialize: dateSerializer }) readonly periodFrom: Date,
        @JsonProperty({ required: true, beforeDeserialize: dateSerializer }) readonly periodTo: Date,
        @JsonProperty({ required: true }) readonly deploymentId: string
    ) {}
}

@JsonObject()
export class ReportInstanceVisibility {
    constructor(
        @JsonProperty({ required: false }) readonly scope: ReportInstanceScope,
        @JsonProperty({ required: false }) readonly userIds: string[]
    ) {}
}

@JsonObject()
export class ReportFrameHeader {
    constructor(
        @JsonProperty({ required: true }) readonly logo: boolean,
        @JsonProperty({ required: true }) readonly templateName: boolean,
        @JsonProperty({ required: true }) readonly period: boolean,
        @JsonProperty({ required: true }) readonly location: boolean
    ) {}
}

@JsonObject()
export class ReportFrameFooter {
    constructor(
        @JsonProperty({ required: true }) readonly generationDate: boolean,
        @JsonProperty({ required: true }) readonly pageNumber: boolean
    ) {}
}

@JsonObject()
export class ReportFrame {
    constructor(
        @JsonProperty({ required: true, type: ReportFrameHeader })
        readonly header: ReportFrameHeader,

        @JsonProperty({ required: true, type: ReportFrameFooter })
        readonly footer: ReportFrameFooter
    ) {}
}

@JsonObject()
export class ReportInstance {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true }) readonly name: string,
        @JsonProperty({ required: true }) readonly templateDashboardId: string,
        @JsonProperty({ required: true }) readonly templateDashboardName: string,
        @JsonProperty({ required: true, type: ReportInstanceContext }) readonly context: ReportInstanceContext,
        @JsonProperty({ required: true, type: ReportFrame }) readonly templateDashboardFrame: ReportFrame,
        @JsonProperty({ required: true }) readonly publishDate: Date,
        @JsonProperty({ required: false, type: ReportInstanceVisibility }) readonly visibility?: ReportInstanceVisibility
    ) {}
}
